import { Component, input,  } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormGroupHelper } from '../../../../helpers/form-group-helper';

import { AResourceTableComponent } from '../../../AResourceTableComponent';
import { TableComponent } from '../../../utils/table/table.component';
import { TableColumnModel } from '../../../../models/table-column.model';
import { LocationModel } from '../../../../models/resources/location.model';
import { LocationService } from '../../../../services/resources/location.service';
import { HttpErrorsService } from '../../../../services/utils/http-errors.service';
import { CustomNotificationService } from '../../../../services/utils/custom-notification.service';
import {finalize} from "rxjs";

@Component({
  selector: 'app-locations-table',
  imports: [ TableComponent, ReactiveFormsModule ],
  template: `<app-table
    [columns]="tableColumns"
    [data]="models()"
    [filterFormGroup]="filterFormGroup"
    [loading]="resourceService.loading()"
    (doFilterRequest)="loadLocations($event)"
    (urlParamsChange)="this.urlParams = $event"
    [hasActiveFilters]="resourceService.apiResponse().filters != undefined"
    [pagination]="resourceService.paginationMeta()"
    [deleteLoadingIds]="this.deleteLoadingIds()"
    />`,
  styles: ``,


})
export class LocationsTableComponent extends AResourceTableComponent<LocationModel>{
  location = input<LocationModel>();

  filterFormGroup: FormGroup = FormGroupHelper.createFilterFormGroup(this.formBuilder,
    [
      'name',
      'address'
    ]
  );

  tableColumns: TableColumnModel[] = [
    {
      name: 'LOCATIONS.NAME',
      selector: [{ selector: 'name' }],
      filterFormControl: this.filterFormGroup.get('name'),
      filterFormControlLabel: 'LOCATIONS.NAME',
      filterUrlParam: 'name',
    },
    {
    name: 'ADDRESS',
    selector: [
      {
        selector: 'address.postcode', suffix:' '
      },
      {
        selector: 'address.place',
        suffix: ', '
      },
      {
        selector: 'address.country',
        suffix:'. '
      },
      {
        selector: 'address.street',
        suffix: ' '
      },
      {
        selector: 'address.houseNumber',
        suffix: ' '
      },
      { selector: 'address.addressSuffix' }
    ],
    filterFormControl: this.filterFormGroup.get('address'),
    filterFormControlLabel: 'ADDRESS',
    filterUrlParam: 'address'
  },
    {
      buttons: [
        {
          iconClass: 'fas fa-external-link-alt fa-lg',
          floating: true,
          outlined: true,
          isObjectLink: true,
          objectBaseLink: '/locations'
        },
        {
          iconClass: 'fas fa-trash fa-lg',
          floating: true,
          outlined: true,
          color: 'danger',
          isDelete: true,
          onClick: ($event) => this.delete($event)
        }
      ]
    }
  ]

  constructor(
    formBuilder: FormBuilder,
    public locationService: LocationService,
    httpErrorsService: HttpErrorsService,
    notificationService: CustomNotificationService,
  ) {
    super(formBuilder,
      locationService,
      httpErrorsService,
      notificationService,
      'LOCATIONS');
  }
  override ngOnInit(): void {
    this.loadLocations();
  }
  loadLocations(params: any = {}): void {

    this.locationService.getAll({
      ...params,

      urlParams: [
        ...(params.urlParams ?? []),

        {
          key: 'type',
          value: 'location'
        },
      ],
    });
  }

  override delete(id: number){
    this.deleteLoadingIds.update((ids) => {
      return [...ids, +id];
    });

    this.locationService
      .delete(id)
      .pipe(
        finalize(() => {
          this.deleteLoadingIds.update((ids) => {
            return ids.filter((i) => i != id);
          });
        }),
      )
      .subscribe({
        next: () => {
          this.loadLocations({
            urlParams: this.urlParams,
            lazyLoad: true,
          })
          this.notificationService.success('LOCATIONS.SUCCESSFULLY_DELETED');
        },
        error: (e) => {
          this.httpErrorsService.handleError(e);
        }
      })
  }
}

